
export default function initArchivePartenaires(): void {
    const $archivePartenaires = document.querySelectorAll<HTMLElement>('.js-extra-terms');
    $archivePartenaires.forEach($container => {
        new ArchivePartenaires($container);
    });
}

class ArchivePartenaires {
    $el: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        if (this.$el) {
            const button = this.$el.querySelector('.js-more-terms');
            const list = this.$el.querySelector('.js-extra-terms-list');

            button?.addEventListener('click', ()=> {
                list?.classList.toggle('extra-terms-list--active');
                button?.classList.toggle('more-terms--active');
            })
        }
    }
}